<template>
  <div :class="`groupDetail ${$store.state.isMobile ? 'groupDetail_mobile' : ''}`">
    <div class="groupDetailPc"></div>
    <mobileBack v-if="$store.state.isMobile" :otherClick="$route.query.type == 'edit' ? true : false" @backOtherClick="goBack" type="white" style="z-index: 22"></mobileBack>
    <topBanner v-if="!$store.state.isMobile"></topBanner>
    <innerWarp :hideContent="true" v-else></innerWarp>
    <div class="shareIcon" v-if="shareToOthersModel && showShareModel">
      点击右上角，选择分享给好友
      <img src="../../assets/ticket/share.png">
    </div>
    <div v-if="!$store.state.isMobile && $route.query.type == 'edit'" style="width: 1200px;margin:auto;margin-top: 30px;">
      <div class="pcToIndex" @click="goBack">返回</div>
    </div>
    
    <div v-if="!$store.state.isMobile && $route.query.type != 'edit'" class="pcContent handelBlock">
      <!-- <div class="buttonLine">
        <div class="buttonWhite">我的订单</div>
        <div class="toIndex">返回首页</div>
      </div> -->
      <pcTabs :reservationType="2"></pcTabs>
      <div class="line" v-if="$store.state.ticketDetail.timeOpen">
        开馆时间<span>{{$store.state.ticketDetail.timeOpen}}-{{$store.state.ticketDetail.timeClose}}</span>
        <div class="pcStopTime" v-if="$store.state.ticketDetail.timeStop">停止入馆时间</div>
        <span v-if="$store.state.ticketDetail.timeStop">{{$store.state.ticketDetail.timeStop}}</span>
      </div>
    </div>
    <div :class="$store.state.isMobile ? 'groupMessage_mobile' : 'pcItemCard'">
      <groupMessage :group="group" :detail="detail"></groupMessage>
    </div>
    <div :class="$store.state.isMobile ? '' : 'pcItemCard'" :style="$store.state.ticketDetail.explainOn && !isFid ? 'margin-bottom: 150px;' : 'margin-bottom: 0'">
      <div :class="`buttonText ${$store.state.isMobile ? '' : 'dissolutionGroup'}`" @click="dissolutionGroup" v-if="!showAddMember">解散团队</div>
      <div v-show="!showAddMember" :class="$store.state.isMobile ? '' : 'pcContent'" :style="$store.state.isMobile ? '' : 'margin-top: 0'">
        <div class="members">
          <div>成员信息</div>
          <div>{{members.length + 1}}人</div>
        </div>
        <div class="itemTitle">成员信息</div>
        <div class="itemCard group">
          <div class="buttons">
            <!-- h5 -->
            <div class="button" @click="addMember" v-if="$store.state.isMobile">添加成员</div>
            <div class="button" @click="shareAddMember"  v-if="$store.state.isMobile">发起分享</div>
            <!-- pc -->
            <div class="button" @click="addPcMember" v-if="!$store.state.isMobile">添加成员</div>
            <!-- pc上传模板组件 -->
            <el-upload
              v-if="!hasModel && !$store.state.isMobile"
              class="upload-demo"
              action="1111"
              ref="uploadModel"
              :http-request="actionModel"
             
              :show-file-list="false">
              <div class="button">批量添加成员</div>
            </el-upload>
            <div class="buttonText" @click="uploadModel" v-if="!$store.state.isMobile && !hasModel">下载成员模板</div>
          </div>
          
          <div class="nameWarp" v-if="group.id">
            <div class="nameDetail" v-for="(item, index) in [group].concat(members)" :key="index">
              <div v-if="!$store.state.isMobile"></div>
              <div>{{item.personName}}</div>
              <div>{{item.cardNum}}</div>
              <div v-if="!item.belongId" class="buttonText buttonTeam" style="color: #000">团长</div>
              <div class="buttonText buttonEdit" @click="edit(index)" v-if="item.belongId"></div>
              <div class="delNameIcon" @click="del(item)" v-if="item.belongId"></div>
            </div>
          </div>
        </div>
        <div class="members" v-if="$store.state.ticketDetail.explainOn && !isFid && museumCode != 'ycsbwg'">
          <div>语音讲解</div>
        </div>
        <div :class="`itemCard explain`" v-if="$store.state.ticketDetail.explainOn && !isFid && museumCode != 'ycsbwg'">
          <span class="contentTitle">是否需要讲解</span>
          <el-radio-group v-model="jsonData.needExplain" :disabled="!maxExplainNum">
            <el-radio :label="1">否</el-radio>
            <el-radio :label="2">是<span v-if="maxExplainNum != 'no'">(该时段剩余{{maxExplainNum}})</span></el-radio>
          </el-radio-group>
        </div>
        <!-- <div :class="`itemCard certificate ${$store.state.isMobile ? 'isMobile' : ''}`" v-if="$route.query.imgOrgOn">
          <span class="contentTitle">请上传团队凭证</span>
          <el-upload
            v-if="!hasUpload"
            class="upload-demo"
            :limit="1"
            action="1111"
            list-type="picture"
            :http-request="actionImg"
            :show-file-list="false">
            <div class="buttonText buttonLeft">
              请点击上传图片
            </div>
          </el-upload>
          <div v-if="hasUpload" class="buttonText hasUpload">已上传</div>
          <div v-if="hasUpload" class="buttonText cancelUpload" @click="hasUpload = false">取消</div>
        </div>
        <div class="itemWarpLine" v-if="$store.state.isMobile">
          <el-checkbox v-model="hasReadNotice"></el-checkbox>
          <span :class="`notice ${hasReadNotice ? 'isNoticed' : ''}`" @click="clickNotice">团队预约须知</span>
          <div class="noticeText">请仔细阅读后并勾选</div>
        </div> -->
      </div>
    </div>
    <div class="pcContent" :style="$store.state.ticketDetail.explainOn ? 'margin-top: 40px;' : 'margin-top: 0'">
      <div class="itemWarpLine" v-if="!$store.state.isMobile">
        <el-checkbox v-model="hasReadNotice" @change="changeReadNotice"></el-checkbox>
        <span :class="`notice ${hasReadNotice ? 'isNoticed' : ''}`" @click="clickNotice">预约须知</span>
        <div class="noticeText">请仔细阅读后并勾选</div>
      </div>
    </div>
    <!-- 按钮 -->
    <div :class="$store.state.isMobile ? 'MobileButtonsWarp' : 'pcButtonsWarp'" v-show="$route.query.type != 'edit' && !showAddMember">
      <div class="buttonText dissolutionGroup" @click="cancelGroup">取消预约</div>
      <div :class="$store.state.isMobile ? 'buttonNormalConfirmSmallContain': 'button3'" @click="submitGroupMembers">提交预约</div>
    </div>
    <addMember v-if="showAddMember" @submitAdd="submitAdd" :editData="editData" :addType="addType" title="成员信息"></addMember>
    <pop v-show="showShareModel">
      <slot>
        <div class="groupShare">
          <div class="code">团队邀请码</div>
          <div class="codeNumber">{{codeNumber}}</div>
          <p>将连接发给好友，邀请好友输入团队邀请码填写个人信息</p>
          <div class="buttonWarp">
            <div class="buttonCancel" @click="cancelShare">取消</div>
            <div class="buttonConfirm shareButton" @click="shareToOthers">分享给好友</div>
          </div>
        </div>
      </slot>
    </pop>
    <div class="pcContent">
      <pop v-if="showAddPcMember">
        <slot>
          <div class="popContent">
            <div class="title">添加成员</div>
            <div class="baseLine"></div>
            <div class="lineContent">
              <div class="name">姓名</div>
              <el-input v-model="editData.personName" placeholder="请输入姓名"></el-input>
            </div>
            <div class="lineContent">
              <div class="name">身份证号</div>
              <el-input v-model="editData.cardNum" placeholder="请输入身份证号码"></el-input>
            </div>
            <div class="lineContent">
              <div class="name">联系电话</div>
              <el-input v-model="editData.phone" placeholder="请输入联系电话" type="number" oninput="if(value.length>11)value=value.slice(0,11)"></el-input>
            </div>
            <div class="buttonConfirm" @click="submitAdd(editData)">保存</div>
          </div>
        </slot>
      </pop>
    </div>
    <notice v-if="showNotice && $store.state.isMobile"></notice>
    <pop v-if="showNotice && !$store.state.isMobile">
      <slot>
        <div class="popContent popNoticeContent">
          <div class="popContentTitle">预约须知</div>
          <div class="popNotice" v-html="$store.state.ticketDetail.bookingNote">
          </div>
        </div>
        <div class="buttonWarp">
          <div :class="`buttonConfirm popHasRead ${readTime ? 'gayText' : ''}`" @click="hasRead">已读{{readTime ? `(${readTime}s)` : ''}}</div>
        </div>
      </slot>
    </pop>
    <pop v-if="showPop">
      <slot>
        <div class="popContent">
          <div class="popNotice">您是否确认所有团队成员已添加完成？可刷新本页更新成员信息。</div>
        </div>
        <div class="buttonWarp">
          <div class="buttonCancel" @click="closePop">取消</div>
          <div class="buttonConfirm" @click="submit">保存</div>
        </div>
      </slot>
    </pop>
    <pop v-if="showPop2">
      <slot v-if="$store.state.isMobile">
        <div :class="`popContent ${!$store.state.isMobile ? 'pcPopContent' : ''}`">
          <div class="notice">{{!$cookie.get('token') ? '您未登录，请选择' : '您登录的账号不是该团队的负责人，请选择'}}</div>
        </div>
        <div class="buttonCancel shareButton" @click="toLogin">我是团长，去登录</div>
        <div class="buttonConfirm shareButton" @click="toGroupCode">我是成员，去填写个人信息</div>
      </slot>
      <slot v-else>
        <div class="pcPopContent">
          <div class="pcNotice">请在移动端操作</div>
        </div>
      </slot>
    </pop>
    <div :class="$store.state.isMobile ? '' : 'pcContent'">
      <pop v-if="showCancelOrder">
        <slot>
          <div class="popContent" :style="$store.state.isMobile ? 'margin-top: 0.3rem' : ''">
            <div class="popNotice" :style="$store.state.isMobile ? '' : 'font-size: 30px;'">您确定要取消本订单？</div>
          </div>
          <div class="buttonWarp">
            <div class="buttonCancel" @click="showCancelOrder = false">取消</div>
            <div class="buttonConfirm" @click="confirmCancelGroup">确定</div>
          </div>
        </slot>
      </pop>
    </div>
    <h5Bottom v-if="$store.state.isMobile"></h5Bottom>
  </div>
</template>

<script>
import groupMessage from '../../components/ticket/groupMessage'
import addMember from '../../components/ticket/addMember.vue'
import pop from '../../components/common/pop.vue'
import topBanner from '../../components/common/topBanner'
import notice from '../../components/common/notice.vue'
import pcTabs from '../../components//ticket/pcTabs.vue'
import Clipboard from 'clipboard'
import mobileBack from '../../components/common/mobileBack'
import innerWarp from '../../components/common/innerWarp'
import h5Bottom from '../../components/common/h5Bottom.vue'
var timeInterval
export default {
  data() {
    return {
      detail: {
        museumName: '',
        time: '19:00-21:00',
      },
      group: {},
      members: [],
      maxExplainNum: 0,
      hasReadNotice: false,
      // needExplain: 1,
      showAddMember: false,
      showShareModel: false,
      codeNumber: '324',
      addType: 'add',
      showAddPcMember: false,
      editData: {},
      noticeDetail: '',
      showNotice: false,
      belongId: '',
      museumCode: '',
      showPop: false,
      jsonData: {},
      showPop2: false,
      hasUpload: false,
      certificate: '',
      shareToOthersModel: false,
      uploadTime: 0,
      hasOpenNotice: false,
      hasModel: false,
      formData: {},
      isFid: false,
      orderDetail: {},
      readTime: 3,
      showCancelOrder: false
    };
  },

  components: {groupMessage, addMember, pop, topBanner, notice, pcTabs, mobileBack, innerWarp, h5Bottom},

  methods: {
    goBack(){ //返回个人中心
      if (this.$route.query.type == 'edit') {
        let query = this.$route.query
        delete query.belongId
        delete query.type
        return this.$router.replace({name: 'personalCenter', query, params: {popShow: 4}})
      }
      
      history.go(-1)
    },
    // 下载成员模板
    uploadModel() {
      let text = '团队成员模板.xlsx'
      location.href = encodeURI(location.origin + location.pathname + text)
    },
    // 批量上传
    actionModel(params) {
      this.formData = new FormData();
      // let formData = new FormData();
      this.formData.append("file", params.file);
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      // console.log(this.museumCode)
      // console.log(this.group.id)
      // console.log(this.formData)
      // console.log(config)

      this.$ajax.post(`/api/ticket/front/people/import-excel?museumCode=${this.museumCode}&belongId=${this.group.id}`, this.formData, config).then((res) => {
        console.log('res')
        console.log(res)
        if (res.status == 200&&res.data) {
          // this.hasModel = true
          this.$message.success('上传成功')
          this.getPeopleInfo()
        }else if(res.status == 200&&!res.data){
          this.$message.error('不能重复添加数据')
          // this.getPeopleInfo()
          // this.$refs.uploadModel.clearFiles()
        }
      }).catch(() =>{
        this.$refs.uploadModel.clearFiles()
      })
    },

    changeReadNotice() {
      if (!this.hasOpenNotice) this.showNotice = true
    },

    actionImg(params) {
      let formData = new FormData();
      formData.append("file", params.file);
      formData.append('folder', `${this.museumCode}/newTicket`)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$ajax.post('/api/file/upload/', formData, config).then((res) => {
        this.hasUpload = true
        this.certificate = res.data
      })
    },

    toLogin() {
      this.$router.replace('/ticket/login')
    },

    toGroupCode() {
      this.$router.replace(`/ticket/groupCode?museumCode=${this.museumCode}&belongId=${this.belongId}`)
    },

    clickNotice() {
      this.showNotice = true
    },

    edit(index) {
      this.$store.state.isMobile ? this.showAddMember = true : this.showAddPcMember = true
      this.addType = 'edit'
      this.editData = JSON.parse(JSON.stringify(this.members[index - 1]))
      this.editData.id ? this.getDetailInfo() : ''
    },

    getDetailInfo() {
      this.$ajax.get(`/api/ticket/front/people/get-by-id?id=${this.editData.id}`).then((res) =>{
        res = res.data
        this.editData.cardNum = res.cardNum
        this.editData.phone = res.phone
      })
    },

    del(item) {
      if (!item.belongId) return
      this.$ajax.delete(`/api/ticket/front/people/${item.id}`).then((res) => {
        this.getPeopleInfo()
      })
    },

    addMember() {
      this.showAddMember = true
      this.addType = 'add'
    },

    addPcMember() {
      this.showAddPcMember = true
      this.addType = 'add'
      this.editData = {}
    },

    submitAdd(data) {
      if (this.addType == 'edit') return this.editPersonal(data)
      if (!data.cardNum || !data.personName) {
        return this.$message.warning('请将基础信息填写完整！')
      }
      if (data.phone && !/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(data.phone)) return this.$message.warning('请输入正确的手机号') 
      this.postAddPersonal(data)
    },

    postAddPersonal(data) {
      data.museumCode = this.museumCode
      data.cardType = 1
      data.belongId = this.belongId
      data.personType = 1
      this.$ajax.post('/api/ticket/front/people', data).then((res) => {
        this.showAddMember = false
        this.showAddPcMember = false
        this.getPeopleInfo()
      })
    },

    editPersonal(data) {
      this.$ajax.put('/api/ticket/front/people', data).then((res) => {
        this.showAddMember = false
        this.showAddPcMember = false
        this.getPeopleInfo()
      })
    },

    shareAddMember() {
      this.$ajax(`/api/ticket/front/people/invitation-code?id=${this.belongId}`).then((res) => {
        this.codeNumber = res.data
        this.showShareModel = true
      })
    },

    cancelShare() {
      this.showShareModel = false
      this.shareToOthersModel = false
    },

    shareToOthers() {
      this.shareToOthersModel = true
    },

    dissolutionGroup() {
      this.$ajax.delete(`/api/ticket/front/people/disband-team?id=${this.belongId}`).then((res) => {
        //解散团队的同时，删除未提交订单
        this.$ajax.delete(`/api/ticket/front/order/temp-order?id=${this.$route.query.orderId}`).then((res) => {
        })
        this.$message.success('解散成功')
        this.$router.replace(`/ticket/home?museumCode=${this.museumCode}${this.$route.query.id ? `&id=${this.$route.query.id}` : ''}${this.$route.query.code ? `&code=${this.$route.query.code}` : ''}`)
      })
    },
    // 取消预约
    cancelGroup() {
      this.showCancelOrder = true
    },
    // 确认取消预约
    confirmCancelGroup() {
      this.$ajax.delete(`/api/ticket/front/order/temp-order?id=${this.$route.query.orderId}`).then((res) => {
        this.$message.success('预约取消成功')
        this.$router.replace(`/ticket/home?museumCode=${this.museumCode}${this.$route.query.id ? `&id=${this.$route.query.id}` : ''}${this.$route.query.code ? `&code=${this.$route.query.code}` : ''}`)
      })
    },

    submitGroupMembers() {
      if (!this.members.length) return this.$message.error('请添加团队成员')
      if (this.$store.state.ticketDetail.orgNumMin && this.members.length < this.$store.state.ticketDetail.orgNumMin - 1) return this.$message.error(`最小团队预约人数为${this.$store.state.ticketDetail.orgNumMin}`)
      if (this.$store.state.ticketDetail.orgNumMax && this.members.length > this.$store.state.ticketDetail.orgNumMax - 1) return this.$message.error(`最大团队预约人数为${this.$store.state.ticketDetail.orgNumMin}`)
      if (!this.hasReadNotice && !this.$store.state.isMobile) return this.$message.error('请阅读并勾选预约须知')
      if (!this.$store.state.isMobile) return this.submit()
      this.showPop = true
      // this.submit()
    },

    submit() {
      console.log(this.isFid)
      if (this.isFid) return this.submitTempOrder()
      let peopleIds = []
      peopleIds.push(this.belongId)
      let data = {
        museumCode: this.museumCode,
        bookingDate: this.jsonData.selectedDate.replace(/\//g, '-'),
        timeSettingId: this.jsonData.timeId,
        orderType: 1,
        peopleIds: peopleIds,
        explainOn: this.jsonData.needExplain == 2 ? true : false,
        belongNum: this.members.length,
        certificate: this.jsonData.imgOrgOn ? (this.$route.params.certificate ? this.$route.params.certificate.join('|') : '') : undefined,
        ticketInfoId: this.$store.state.ticketDetail.id
      }
      if (this.$route.query.flyingCinemaNum || this.$route.query.chairNum) {
        data.flyingCinemaNum = this.$route.query.flyingCinemaNum ? parseInt(this.$route.query.flyingCinemaNum) : 0
        data.chairNum = this.$route.query.chairNum ? parseInt(this.$route.query.chairNum) : 0
      }
      this.$ajax.post('/api/ticket/front/order', data).then((res) => {
        if (!res.rel) return
        this.$router.push(`/ticket/re_success?museumCode=${this.museumCode}&orderId=${res.data}${this.$store.state.ticketDetail.id ? `&id=${this.$store.state.ticketDetail.id}` : ''}`)
      })
    },

    closePop() {
      this.showPop = false
    },

    getPeopleInfo() {
      console.log(this.group.id)
      console.log(this.belongId)
      this.$ajax(`/api/ticket/front/people/info?museumCode=${this.museumCode}&belongId=${this.belongId}&personType=1`).then((res) => {
        this.members = res.data
        console.log('getPeopleInfo')
        console.log(res.data)
        if (!res.data.length) {
          setTimeout(() => {
            this.getPeopleInfo()
            this.uploadTime ++
          }, 2000)
        }
        // if (!res.data.length) {
        //   setTimeout(() => {
        //     // this.getPeopleInfo()
        //     // this.uploadTime ++
        //   }, 2000)
        // }
      })
    },

    getGroup() {
      this.$ajax(`/api/ticket/front/people/belong-info?museumCode=${this.museumCode}&personType=4`).then((res)=> {
        let data = res.data.find((item) => {return item.id == this.belongId})
        if (!data) {
          return this.showPop2 = true
        }
        this.group = data
        var pat =/(\d{3})\d*(\d{4})/;
        let phone = this.group.phone.replace(pat,'$1****$2');
        if ((this.$cookie.get('ticket_phone') != phone)) {
          this.toGroupCode()
        } else if (this.isFid) {
          this.getOrderDetail(this.$route.query.orderId)
        }
      })
    },

    hasRead() {
      if (this.readTime) return
      this.showNotice = false
      this.hasReadNotice = true
      this.hasOpenNotice = true
    },

    // 获取临时订单的信息
    getOrderDetail(id) {
      this.$ajax(`/api/ticket/front/order/temp-order-by-id?id=${id}`).then((res) => {
        this.orderDetail = res.data
        this.detail.time = this.orderDetail.timeRange.replace(':00-', '-').substring(0,11)
        this.detail.bookingDate = this.orderDetail.bookingDate.split(' ')[0]
        // this.group.orgName = this.orderDetail.orgName
        // this.group.personName = this.orderDetail.peopleName
        // this.group.phone = this.orderDetail.phone
      })
    },

    // 提交临时订单
    submitTempOrder() {
      this.$ajax.post(`/api/ticket/front/order/team?tempOrderId=${this.$route.query.orderId}`).then((res)=>{
        if (res.rel) {
          this.$router.push(`/ticket/re_success?museumCode=${this.museumCode}&orderId=${res.data}${this.$store.state.ticketDetail.id ? `&id=${this.$store.state.ticketDetail.id}` : ''}`)
        }
      })
    }
  },

  created() {
    this.isFid = !isNaN(Number(this.$route.query.museumCode)) ? true : false
    this.museumCode = this.$cookie.get('museumCode') || this.$route.query.museumCode
    if (!this.isFid) {
      this.belongId = this.$route.query.belongId
      this.group = this.$store.state.selectGroup || {}
      this.jsonData = this.$route.query
      this.detail.time = this.jsonData.timeLabel
      this.detail.museumName = this.jsonData.museumName
      this.maxExplainNum = this.jsonData.maxExplainNum
    } else{
      this.belongId = this.$route.query.belongId
    }
    if (!this.$cookie.get('token')) {
      return this.showPop2 = true
    }
    this.getPeopleInfo(this.belongId)
    if (this.group.phone) {
      var pat =/(\d{3})\d*(\d{4})/;
      let phone = this.group.phone.replace(pat,'$1****$2');
      if (this.$cookie.get('ticket_phone') != phone) {
        this.toGroupCode()
      }
    }
    // debugger
    if (!this.group.id && this.belongId) {
      this.getGroup()
    }
  },
  watch: {
    showNotice: {
      handler(val, valOld) {
        if (val) {
          if (this.hasOpenNotice) return
          this.readTime = 3
          timeInterval = setInterval(() =>{
            if (!this.readTime) return clearInterval(timeInterval)
            this.readTime --
          }, 1000)
        }
      }
    }
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
  .groupDetail{
    .groupDetailPc{
      background: url('../../assets/ticket/re_bg.png') left bottom/cover no-repeat;
      width: 100%;
      height: 100vh;
      position: fixed;
      z-index: -1;
    }
    &.groupDetail_mobile{
      background: #FDFBF7;
      padding-bottom: 3.5rem;
      .groupMessage_mobile{
        margin-top: -1.5rem;
        z-index: 2;
        position: relative;
      }
      .nameDetail{
        color: #666666;
        font-size: 0.389rem;
        div:nth-child(1){
          width: 1.7rem;
          margin-left: 0.3rem;
        }
        div:nth-child(2){
          width: 4rem;
          margin: 0 0.4rem 0 0.1rem;
        }
        .buttonTeam{
          width: auto;
          margin-left: 0.05rem;
        }
        .buttonEdit{
          font-size: 0;
          width: 0.48rem !important;
          height: 0.48rem;
          margin-right: 0.5rem;
        }
      }
      .delNameIcon{
        width: 0.58rem;
        height: 0.58rem;
      }
    }
    .shareButton{
      width: unset;
      padding: 0 0.5rem;
      margin-bottom: 0.8rem;
    }
    .shareIcon{
      position: fixed;
      top: 0.5rem;
      right: 0.5rem;
      z-index: 9999;
      color: white;
      img{
        width: 2rem;
        height: 2rem;
      }
      font-size: 0.5rem;
    }
    .itemCard{
      padding: 0.3rem;
      .button{
        font-size: 0.4rem;
        font-weight: 500;
        // width: 2.5rem;
        // height: 1rem;
        border-radius: 0.2rem;
        background-color: #fff;
        line-height: 0.4rem;
        display: inline-block;
        padding: 0.3rem 0.5rem 0.3rem 1.2rem;
      }
      .nameDetail{
        margin-top: 0.3rem;
        .teamOne{
          margin-left: -3px;
          font-size: 12px;
          font-weight: bold;
        }
        .noBorder{
          border-color: rgba(0,0,0,0);
        }
        .buttonEdit{
          background: url('../../assets/ticket/edit.png') 0 0/contain no-repeat;
        }
        .delNameIcon{
          background: url('../../assets/ticket/delete.png') 0 0/contain no-repeat;
        }
      }
    }
    .explain{
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .certificate{
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .hasUpload{
      color: #606266;
    }
    .cancelUpload{
      margin-left: 1rem;
    }
    .members{
      margin: 0.5rem 0.6rem;
      display: flex;
      justify-content: space-between;
      font-size: 0.5rem;
      font-weight: 500;
    }
    .itemTitle{
      display: none;
    }

    .popNotice{
      font-size: 0.5rem;
      margin-bottom: 0.5rem;
    }

    .pcPopContent .pcNotice{
      margin-top: 30%;
      font-size: 40px;
    }
    .group{
      .button{
        margin: 0.1rem 0;
        &:nth-child(1){
          margin-right: 1rem;
          position: relative;
          &::before{
            position: absolute;
            content: '';
            display: inline-block;
            height: 0.5rem;
            width: 0.5rem;
            top: 0.25rem;
            left: 0.42rem;
          }
        }
        &:nth-child(2){
          position: relative;
          &::before{
            position: absolute;
            content: '';
            display: inline-block;
            height: 0.5rem;
            width: 0.5rem;
            top: 0.25rem;
            left: 0.45rem;
          }
        }
      }
    }
    .buttonWarp{
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .MobileButtonsWarp{
      text-align: center;
      position: relative;
      div{
        display: inline-block;
        margin: 0;
      }
      .dissolutionGroup{
        position: absolute;
        bottom: -0.9rem;
        margin-left: -0.78rem;
        text-decoration:underline;
        left: 50%;
        font-size: 0.39rem;
        color: #333333;
      }
      .button3{
      }
      .buttonNormalConfirmSmallCancel{
        margin-right: 1.456rem;
      }
    }

    .hasSubmitOrder{
      font-size: 18px;
    }
    .pcButtonsWarp{
      text-align: center;
      position: relative;
      div{
        display: inline-block;
      }
      .dissolutionGroup{
        position: absolute;
        top: 30px;
        left: 50%;
        margin-left: 250px;
        font-size: 18px;
      }
      .button3{
      }
      .button4{
        margin-right: 70px;
      }
    }

    .pcContent{
      width: unset;
      .buttonWarp{
        div{
          margin: 0 40px;
        }
      }
      .uploadButtonMobile{
        width: 120px;
        height: 40px;
        border-radius: 10px;
        margin-top: 0;
        font-size: 18px !important;
        text-align: center;
        line-height:40px;
        cursor: pointer;
        position: relative;
        border-radius: 6px;
        margin-left: 25px;
        color: #fff;
        letter-spacing: 0.1em;
        transform: translateY(-1px);
        div{
          font-size: 16px !important;
          line-height: 20px;
          position: absolute;
          top: 70px;
          left: 0;
          width: calc(100% - 10px);
          padding: 0 5px;
        }
      }
      .contentTitle{
        font-size: 26px;
      }
      .buttonLine{
        width: 7rem;
        margin: auto;
        position: relative;
        div{
          display: inline-block;
        }
        .buttonRed{
          margin-right: 0.5rem;
        }
        .toIndex{
          position: absolute;
          border: 1px solid #333333;
          color: #333333;
          height: 0.2rem;
          width: 0.6rem;
          line-height: 0.2rem;
          border-radius: 0.1rem;
          font-size: 0.03rem;
          top: 0.02rem;
          right: 0.5rem;
          cursor: pointer;
        }
      }
      .tips{
        text-align: left;
        margin-top: 10px;
        margin-left: 30px;
      }
      .buttonLine{
        width: 7rem;
        margin: auto;
        position: relative;
        div{
          display: inline-block;
        }
        .buttonRed{
          margin-right: 0.5rem;
        }
        .toIndex{
          position: absolute;
          border: 1px solid #333333;
          color: #333333;
          height: 0.2rem;
          width: 0.6rem;
          line-height: 0.2rem;
          border-radius: 0.1rem;
          font-size: 0.03rem;
          top: 0.02rem;
          right: 0.5rem;
          cursor: pointer;
        }
      }
      .line{
        font-size: 24px;
        font-weight: 500;
        text-align: center;
        // line-height: 0.23rem;
        margin-left: 30px;
        margin-top: 0.2rem;
        .pcStopTime{
          display: inline-block;
          margin-left: 30px;
        }
        span{
          margin-left: 0.2rem;
          font-size: 22px;
        }
      }
      .itemWarpLine{
        margin-bottom: 0.2rem;
      }

    }
    .pcItemCard{
      margin: 40px auto;
      width: 1020px;
      position: relative;
      .members{
        display: none;
      }
      .itemTitle{
        display: block;
      }
      .group{
        background-color: #fff;
        padding: 30px !important;
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.04);
      }
      .nameWarp{
        // width: 5.5rem;
        .nameDetail{
          margin-left: 180px;
          margin-bottom: 15px;
          margin-top: 0;
          .teamOne{
            margin-left: -2px;
            font-size: 17px;
            font-weight: bold;
          }
          .buttonEdit, .delNameIcon{
            width: 25px;
            height: 25px;
          }
          .buttonEdit{
            margin-right: 20px;
          }
          div:nth-child(3){
            text-align: left;
          }
          div:nth-child(2){
            width: 85px;
            text-align: left;
          }
        }
      }
      .buttons{
        text-align: center;
        position: relative;
        margin-bottom: 20px;
        .button{
          text-align: center;
          font-size: 25px;
          line-height: 25px;
          padding: 15px 20px 15px 50px;
          display: inline-block;
          border: solid 0.01rem #d2d2d2;
          border-radius: 0.1rem;
          color: #000 !important;
          &:before{
            height: 25px;
            width: 25px;
            top: 14px;
            left: 15px;
          }
          &:nth-child(1){
            margin-right: 20px;
          }
          &:nth-child(2){
            margin-bottom: 0;
          }
        }
        .buttonText{
          font-size: 18px !important;
          display: inline-block;
          margin-left: 20px;
          position: absolute;
          right: 30px;
          top: 30px;
        }
      }
      .explain{
        justify-content: flex-start;
        position: absolute;
        bottom: -140px;
        left: 0;
        width: 1040px;
        padding: 40px 80px !important;
      }
      .dissolutionGroup{
        position: absolute;
        top: 40px;
        right: 145px;
        font-size: 0.12rem !important;
      }
    }
    .button3{
      margin: auto;
    }
    .popHasRead{
      font-size: 20px;
      width: 160px;
      height: 52px;
      line-height: 52px;
      margin-top: 30px;
    }
    .gayText{
      opacity: 0.9;
      background: #999;
    }
    .popNoticeContent{
      overflow-y: scroll;
      height: 3rem;
    }
    .popContentTitle{
      font-size: 0.3rem;
      text-align: center;
      font-weight: 500;
      margin-bottom: 0.3rem;
    }
    .popNoticeContent .popNotice{
      font-size: 24px;
      line-height: 36px;
      text-align: left;
      // overflow: scroll;
    }
    .popContentTitle{
      font-size: 30px;
      margin-bottom: 40px;
    }
    .popContent{
      .notice{
        font-size: 0.4rem;
      }
    }
    .pcPop{
      .shareButton{
        font-size: 0.3rem;
        height: 0.6rem;
        line-height: 0.6rem;
        margin-bottom: 0.2rem;
      }
    }
  }
</style>
<style type="text/css" lang="scss">
  .groupDetail_mobile{
    .itemCard{
      background: #FDFBF7;
      box-shadow: 0px 0.05rem 0.26rem rgba(0, 0, 0, 0.08);
      margin: 0.5rem 0.4rem;
      padding-top: 1.8rem !important;
      position: relative;
      border-radius: 0.416rem;
      &:before{
        position: absolute;
        content: '';
        display: inline-block;
        top: 0.08rem;
        left: 0.08rem;
        width: 9.04rem;
        height: 1.2rem;
        background: linear-gradient(180deg, #F7E9DE 0%, rgba(242, 230, 208, 0) 100%);
        border-radius: 0.416rem 0.416rem 0px 0px;
      }
      .itemCardTitle{
        position: absolute;
        left: 0.65rem;
        top: 0.5rem;
        font-size: 0.494rem;
      }
      // 语音讲解
      &.explain{
        padding: 1.85rem 0.3rem 0.85rem 0.6rem !important;
        .el-radio-group{
          margin-top: 0.1rem;
          margin-left: 0.2rem;
          .el-radio__label{
            color: #999999;
          }
        }
      }
      // 上传
      &.certificate{
        padding: 1.85rem 0.3rem 0.85rem 0.6rem !important;
        .fileDemo{
          font-size: 0.34rem;
          margin-left: 0.25rem;
        }
        .uploadImgs div{
          color: #666666;
          font-size: 0.34rem;
        }
        .uploadButtonMobile {
          transform: translateY(0.01rem);
        }
        &.showUploadButton{
          padding-top: 1.5rem !important;
        }
      }
      &.group{
        background: #FFFFFF;
        .buttons{
          .button{
            border-radius: 0.2rem;
            padding: 0.23rem 0.35rem 0.23rem 0.95rem;
            &:nth-child(2){
              border: 0.026rem solid #333333;
              &:before{
                background: url('../../assets/ticket/shareIcon.png') 0 0/contain no-repeat;
                -webkit-mask: unset;
                mask: unset;
                height: 0.62rem;
                width: 0.62rem;
                top: 0.13rem;
                left: 0.31rem;
              }
            }
            &:nth-child(1){
              margin-right: 0.9rem;
              &:before{
                -webkit-mask: unset;
                mask: unset;
                content: '+';
                background: #ffffff;
                font-size: 0.7rem;
                font-weight: 0;
                top: 0.23rem;
                left: 0.33rem;
              }
            }
          }
        }
      }
    }
    .groupMessage_mobile{
      .itemCard{
        padding: 0.3rem 0.5rem;
        padding-top: 0.3rem !important;
        &:before{
          display: none;
        }
      }
    }
    .codeNumber{
      padding-left: 0.65rem !important;
    }
  }
  .groupDetail .upload-demo{
    display: inline-block;
  }
  .groupDetail .loadingMode{
    padding-right: 70px !important;
    position: relative;
    &:before{
      display: none !important;
    }
    &:after{
      width: 30px;
      height: 30px;
      display: inline-block;
      position: absolute;
      content: '';
      top: 14px;
      right: 24px;
    }
  }
  .groupDetail .popNotice p{
    margin: 0;
  }
  .groupDetail .pcItemCard .title{
    font-size: 25px !important;
  }
  .groupDetail .pcContent .buttonLine{
    width: 1200px;
  }
  .groupDetail .pcItemCard .itemCard{
    background: unset;
  }
  .groupDetail .popNoticeContent{
    .popNotice{
      width: 100%;
      font-size: unset;
    }
    p,h3, pre{
      white-space: normal;
      width: 100%;
      margin-block-start: 0;
      margin-block-end: 0;
    }
    p{
      margin: 10px 0 !important;
    }
  }
</style>


